<video autoplay loop width="480">
    <source type="video/mp4" src="../../../assets/video/404 Error.mp4">
</video>